  export class OneTimeFeeModel {
        amount: number;
        currencyCode: string;
    }
